module.exports = __webpack_public_path__ + "static/media/uwr_logo.4a9181f2.svg";